import type { ZudokuConfig } from "zudoku";
import './src/styles/global.css';

import LockedLoaderImage from "./src/shared/ui/data_display/locked_loader_image";
// import { navigation } from "./src/app/config/navigation/navigation";



const config: ZudokuConfig = {
  docs: {
    files: "pages/**/*.{md,mdx}", // Our markdown files
    publishMarkdown: true, // Generate .md files
    llms: {
      llmsTxt: true, // Generate llms.txt
      llmsTxtFull: true, // Generate llms-full.txt
      includeProtected: false, // Exclude protected routes
    },

    defaultOptions: {

    }
  },
  site: {
    logo: {
      src: { light: "/logo-light.svg", dark: "/logo-dark.svg" },
      alt: "Twitblit — social network and developer platform",
      width: "35px",
      href: 'https://twitblit.ru',
    },

    showPoweredBy: false,

    footer: {
      copyright: (() => {
        const year = new Date().getFullYear();

        return year === 2026
          ? `© 2026 Twitblit. Все права защищены. ИП Кузмичёв Владислав Денисович`
          : `© 2026-${year} Twitblit. Все права защищены. ИП Кузмичёв Владислав Денисович`;
      })(),

      social: [
        {
          icon: <LockedLoaderImage src="/icons/brands/social/ic_telegram.png" alt="Twitblit в Telegram" width={24} height={24} />,
          href: "https://t.me/twitblit",
        }
      ]
    },

  },

  // search: {
  //   type: "pagefind",
  //   // Optional: Maximum number of sub results per page
  //   maxSubResults: 3,
  //   // Optional: Configure search result ranking (defaults shown below)
  //   ranking: {
  //     termFrequency: 0.8,
  //     pageLength: 0.6,
  //     termSimilarity: 1.2,
  //     termSaturation: 1.2,
  //   },
  // },


  theme: {
    light: {
      primary: '#5f18da'
    },
    dark: {
      primary: '#5f18da'
    }
  },

  // Редиректы с информационных страниц на главную
  redirects: [
    { from: '/about', to: '/' },
    { from: '/about/', to: '/' },
    { from: '/o-nas', to: '/' },
    { from: '/o-nas/', to: '/' },
    { from: '/about-us', to: '/' },
    { from: '/about-us/', to: '/' },
  ],

  navigation: [
    // Документация пользователей
    {
      type: "category" as const,
      label: "Документация пользователей",
      items: [
        { type: "filter", placeholder: "Найти интересное" },

        // Начальная страница документации
        {
          type: "doc",
          icon: "info",
          file: "ru/users/introduction.mdx",
          path: '/',
          label: "О Twitblit"
        },

        {
          type: "category" as const,
          icon: "scale",
          label: "Политики и юридические документы",
          link: "ru/users/legal/introduction.mdx",
          items: [
            {
              "type": "doc",
              "file": "ru/users/legal/privacy-policy.mdx",
              "label": "Политика конфиденциальности",
              "icon": "file-text"
            },
            {
              "type": "doc",
              "file": "ru/users/legal/terms-of-use.mdx",
              "label": "Пользовательское соглашение",
              "icon": "file-text"
            },
            {
              "type": "doc",
              "file": "ru/users/legal/cookie-policy.mdx",
              "label": "Политика использования cookie",
              "icon": "cookie"
            },
            {
              "type": "doc",
              "file": "ru/users/legal/community-guidelines.mdx",
              "label": "Правила сообщества и модерации",
              "icon": "shield-check"
            },
            {
              "type": "doc",
              "file": "ru/users/legal/recommendation-tech.mdx",
              "label": "Рекомендательные технологии",
              "icon": "sparkles",
            },
          ],
        },
      ],
    },

    // Документация разработчиков
    {
      type: "category" as const,
      label: "Документация разработчиков",
      items: [
      ],
    },

    // Twitblit SDK
    {
      type: "category" as const,
      label: "Twitblit SDK",
      items: [
      ],
    },

    // Twitblit API
    {
      type: "category" as const,
      label: "Twitblit API",
      items: [
      ],
    }
  ],


  sitemap: {
    // The base url for your site
    // Required
    siteUrl: "https://help.twitblit.ru",
    // The change frequency for the pages
    // Defaults to daily
    changefreq: "daily",
    // The priority for the pages
    // Defaults to 0.7
    priority: 0.7,
    // The output directory for the sitemap
    // Defaults to undefined
    outDir: "sitemaps/",
    // Whether to include the last modified date
    // Defaults to true
    autoLastmod: true,
    // The pages to exclude from the sitemap
    // Can also be a function that returns an array of paths
    // () => Promise<string[]>
    exclude: ["/404", "/private/page"]
  }


};

export default config;
